module.exports = __webpack_public_path__ + "img/home-robotarm.c517645b.svg";